import { ElMessage } from 'element-plus';
import { useWhatsApp } from '@/composables/useWhatsApp';
import { getShareQuoteId, getShareValidity, runShare } from './shareHelpers';
import type { ShareContext } from './types';

const resolveContact = (
  sources: ShareContext['sources'],
  onEditDriver: () => void
): { telefono: string; email: string } | null => {
  const personal = sources.quoteData.personalData;
  const telefono = personal?.whatsapp?.trim();
  if (!telefono) {
    ElMessage.warning('Completa tu teléfono para enviar la cotización por WhatsApp');
    onEditDriver();
    return null;
  }
  const email = personal?.email?.trim();
  if (!email) {
    ElMessage.warning('Completa tu correo electrónico para enviar la cotización');
    onEditDriver();
    return null;
  }
  return { telefono, email };
};

export function useQuoteWhatsApp({ sources, isChubbSelected, onEditDriver }: ShareContext) {
  const { isLoading: isSendingWhatsApp, sendQuoteWhatsApp } = useWhatsApp();

  const handleSendWhatsApp = async (): Promise<void> => {
    if (isChubbSelected.value) {
      ElMessage.info('El envío por WhatsApp no está disponible para Chubb en este momento.');
      return;
    }
    const idCotizacion = getShareQuoteId(sources);
    if (!idCotizacion) return;

    const contact = resolveContact(sources, onEditDriver);
    if (!contact) return;
    const { telefono, email } = contact;
    const personal = sources.quoteData.personalData;

    await runShare(
      () =>
        sendQuoteWhatsApp({
          idCotizacion,
          telefono,
          email,
          nombre: personal?.fullName,
          prima: sources.quotesResponse.value?.Cobertura?.PrimaTotal ?? 0,
          fechaVigencia: getShareValidity(sources),
          quoteData: sources.quoteData,
        }),
      {
        success: 'Cotización enviada por WhatsApp',
        failureFallback: 'Error al enviar por WhatsApp',
        unknownError: 'Error desconocido al enviar WhatsApp',
      }
    );
  };

  return { isSendingWhatsApp, handleSendWhatsApp };
}
